module.exports = __webpack_public_path__ + "img/speaker_3.d9ae8ed4.png";